import { h } from 'preact'; /** @jsx h */

import SupportUsForm from '../../forms/SupportUsForm';

import CTABlock from '../components/paulinge/CTABlock/CTABlock';
import Content from '../components/paulinge/Content/Content';
import FactPopup from '../components/paulinge/FactPopup/FactPopup';
import Heading from '../components/paulinge/Heading/Heading';
import Hero from '../components/paulinge/Hero/Hero';
import Image from '../components/paulinge/Image/Image';
import InlineCTA from '../components/paulinge/InlineCTA/InlineCTA';
import Paragraph from '../components/paulinge/Paragraph/Paragraph';
import ParallaxBanner from '../components/paulinge/ParallaxBanner/ParallaxBanner';
import ParallaxContent from '../components/paulinge/ParallaxBanner/ParallaxContent/ParallaxContent';
import Quote from '../components/paulinge/Quote/Quote';
import Section from '../components/paulinge/Section/Section';
import StickyCTA from '../components/paulinge/StickyCTA/StickyCTA';
import Video from '../components/paulinge/Video/Video';

import '../styles/paulinge/han-dode-foran-oynene-vare.scss';

const renderFromDone = id => {
    if (window.location.hash === '#' + id) {
        const elemtentWithForm = document.querySelector('#' + id);

        elemtentWithForm.scrollIntoView();
    }
};

const HanDodeForanOyneneVare = () => {
    return (
        <div className="to-min-foer-hjertet-stoppet">
            <Hero
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/05/ph-paul-inge-hero-3.jpg"
                alt="Redningsarbeidere samarbeider rundt en båre ute i naturen."
            >
                <Heading type="h1" className="hero-title">
                    <span className="hero-title-section">
                        <span>– Han døde</span>
                    </span>
                    <span className="hero-title-section">foran øynene våre</span>
                </Heading>
            </Hero>

            <Section top color="secondary">
                <StickyCTA
                    title="Bli støttemedlem"
                    text="Din støtte går til livreddende innovasjon og utvikling - slik som videoløsningen brukt i denne saken."
                    buttonText="Bli støttemedlem"
                    link="#stott-oss"
                    orientation="right"
                    icon
                />
                <Content width="small">
                    <Paragraph type="ingress" color="all-white">
                        En søndag ettermiddag går Are, Heidi og Samson Nyrud Uppheim opp
                        Malmangernuten i Rosendal. På veien møter de på Paul Inge Kronheim (54). Det
                        blir et møte som skal handle om liv eller død.
                    </Paragraph>
                    <Paragraph
                        type="byline"
                        textAndPhoto="Karoline Lervik Sandvold"
                        color="all-white"
                    />
                    <Paragraph type="normal" color="all-white">
                        Det er en varm, men overskyet søndag i juli. Samson Nyrud Uppheim (22) er
                        hjemme hos foreldrene Are og Heidi. De tre har avtalt å gå opp
                        Malmangernuten i Rosendal denne dagen. Planen var å gå tidlig på
                        formiddagen, men tilfeldighetene skulle ha det til at de ikke startet på
                        turen før rundt 16-tiden.
                    </Paragraph>
                    <Paragraph color="all-white">
                        På vei opp til første nivå, litt over halvveis til toppen på 890 moh hører
                        de en hund som bjeffer. Og den stopper ikke.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        – Jeg tenkte at her er det noe som har skjedd, forteller Are.
                    </Quote>
                    <Paragraph color="all-white">
                        På en helle ligger Paul Inge Kronheim (54). Han er bevisst, men Are, Heidi
                        og Samson ser at noe er galt.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        – Vi gikk selvfølgelig rett bort til han og spurte om alt var bra, forteller
                        Heidi.
                    </Quote>
                    <Paragraph type="background" color="all-white">
                        Paul Inge svarer at han har veldig vondt i armene og brystet, men at han har
                        ringt kona si som har ringt 113 (AMK).
                    </Paragraph>
                    <Paragraph type="normal" color="all-white">
                        Kona Anne Smaadal Kronheim befinner seg på båten deres nede i Rosendal,
                        hjelpeløs og engstelig.
                    </Paragraph>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-1"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/05/malmangernuten.jpg"
                alt="Malmanernuten i Rosendal sett nedenfra."
                orientation="right"
                color="off-white"
                colorTop="secondary"
                colorBottom="off-white"
            >
                <ParallaxContent orientation="left">
                    <Quote animation="fade-up" color="primary-white" className="no-margin">
                        – Jeg tenkte mye på at kona hans sikkert var veldig redd, og at alt hun
                        kunne gjøre var å forsøke og se opp for å finne ut hvor Paul Inge var,
                        forteller Are.
                    </Quote>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="off-white">
                <Content width="small">
                    <Heading>Døde foran oss</Heading>
                    <Paragraph>
                        Are ringer 113 som kan bekrefte at de har kona Anne på tråden. De stiller
                        spørsmål om hva slags type smerte Paul Inge har, og de oppdaterer familien
                        Nyrud Uppheim om at luftambulansen, som allerede var på et annet oppdrag i
                        Odda, er på vei.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Det neste som skjedde var at hun fra AMK sa at hun skulle oppdatere kona
                        om hva som skjedde, og om tilstanden til Paul Inge, forteller Are.
                    </Quote>
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/05/familien-Nyrud-Uppheim.jpg"
                        alt="Familien Nyrud Uppheim fra venstre: Samson, Heidi og Are."
                        caption="Familien Nyrud Uppheim fra venstre: Samson, Heidi og Are."
                        captionColor="all-black"
                    />
                    <Paragraph>
                        Ikke lenge etter at AMK setter telefonsamtalen med familien Nyrud Uppheim på
                        vent ser de at livet svinner hen fra øyene til Paul Inge.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Han døde rett foran oss. Øyene rullet bak og vi kunne se at han ikke
                        lenger pustet, sier Samson.
                    </Quote>
                    <Paragraph>
                        Are, Heidi og Samson nøler ikke et sekund. De ruller Paul Inge over på
                        ryggen og Are setter umiddelbart i gang med hjertekompresjoner. Samson
                        jobber for å åpne luftveiene mens Heidi tar over kommunikasjonen med AMK.
                    </Paragraph>
                    <Paragraph>
                        AMK sender en lenke på sms til Heidi, til en videooverføring slik at de kan
                        se Paul Inge og bistå familien Nyrud Uppheim mens de forsøker å redde livet
                        hans.
                    </Paragraph>
                    <Paragraph type="background" color="secondary">
                        Det var utrolig nyttig at de kunne se Paul Inge og hva vi gjorde. Vi trodde
                        flere ganger at vi hadde fått i gang hjertet hans for det så ut som han
                        våknet. Vi la han derfor i sideleie, men da sa hun fra AMK at det var så
                        overfladisk at vi måtte fortsette å gjøre hjertekompresjoner, forteller
                        Samson.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        – Ja, det var veldig godt å ha øyne fra AMK med oss som kunne hjelpe oss,
                        legger Are til.
                    </Quote>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-2"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/05/ph-paul-inge-parallax-2.jpg"
                alt="Samson med sekk på ryggen foran legehelikopteret som har landet på fjellet."
                orientation="right"
                color="off-white"
                colorTop="off-white"
                colorBottom="secondary"
            >
                <ParallaxContent orientation="left">
                    <Paragraph color="all-white" className="no-margin">
                        20-30 minutter etter at hjertet til Paul Inge stoppet å slå hører Are, Heidi
                        og Samson rotorene fra luftambulansehelikopteret i det fjerne.
                    </Paragraph>
                </ParallaxContent>
            </ParallaxBanner>

            <Section color="secondary">
                <Content width="small">
                    <Heading type="h3" color="all-white" className="no-margin">
                        Var på sommerferie
                    </Heading>
                    <Paragraph color="all-white" className="no-margin">
                        Mens den dramatiske hendelsen pågår på fjellet, står Anne nede ved båten
                        deres. Hun og Paul Inge er på sommerferie sammen med flere vennepar. De kom
                        til Rosendal samme morgen fra Romsa, og nøt en middag før Paul Inge og
                        kameraten Morten, bestemte seg for å gå opp Malmangernuten. På veien opp
                        begynner Paul Inge å føle seg sliten. Han sier derfor i fra til Morten at
                        han kan gå i forveien og at de skulle møtes senere. Ikke lenge etter kommer
                        smertene.
                    </Paragraph>
                    <Paragraph color="all-white">
                        Anne fortsetter å fortelle at hun ble ordentlig engstelig da hun ikke fikk
                        tak i Paul Inge etter å ha snakket med ham første gangen.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        – Jeg ringte derfor AMK tilbake, som fortalte meg at hun snakket med
                        familien Nyrud Uppheim. Hun fortalte meg også at tilstanden til Paul Inge
                        hadde forverret seg og at hjertet hans hadde stoppet, men at Are, Heidi og
                        Samson gjorde det de kunne for å redde ham. Det var en brutal beskjed å få,
                        sier Anne.
                    </Quote>
                    <Heading type="h3" color="all-white">
                        Trodde ikke Paul Inge ville overleve
                    </Heading>
                    <Image
                        src="https://norskluftambulanse.no/wp-content/uploads/2024/05/ph-paul-inge-seaking-1.jpg"
                        alt="Luftambulansemannskapet ser redningshelikopteret fra 330 skvadronen komme inn over fjorden."
                        caption="Luftambulansemannskapet ser redningshelikopteret fra 330 skvadronen komme inn over fjorden."
                        captionColor="all-white"
                    />

                    <Paragraph color="all-white">
                        Luftambulansen fikk landet et lite stykke fra der Paul Inge lå.
                        Anestesilegen, redningsmann og pilot kom løpende med hjertestarter og annet
                        utstyr for å klargjøre Paul Inge slik at han kunne bli tatt med til
                        Haukeland sykehus.
                    </Paragraph>
                </Content>
                <Content width="small" type="video-float-right">
                    <Video
                        src="https://player.vimeo.com/video/948702497?autoplay=1&autopause=0&muted=1&loop=1&title=0&byline=0&portrait=0"
                        padding="177.78%"
                        caption="Redningshelikopteret Sea King fra 330 skvadronen heiser Paul Inge opp fra fjellet."
                        color="all-white"
                    />
                    <div>
                        <Quote animation="fade-up" color="primary-white">
                            – Jeg må si at luftambulansemannskapet var utrolig profesjonelle. De
                            hadde full kontroll under hele hendelsen og fikk startet hjertet hans
                            igjen med hjertestarteren. Du får bare en vanvittig ro når de kommer,
                            forteller Are.
                        </Quote>
                        <Paragraph color="all-white">Han legger til:</Paragraph>
                        <Quote animation="fade-up" color="primary-white">
                            – Men for å være ærlig så trodde jeg ikke at det kom til å ende bra, men
                            sett i etterkant har Paul Inge hatt maks flaks med veldig mye av det som
                            skjedde den dagen.
                        </Quote>
                        <Paragraph color="all-white">
                            I dag er ikke luftambulansehelikoptrene utstyrt med heis, så et
                            <FactPopup
                                factText="Luftforsvaret driftet og opererte Sea King redningshelikoptrene. Disse ble erstattet av SAR Queen fra 2024."
                                factTitle="Sea King redningshelikopter"
                            >
                                Sea King redningshelikopter
                            </FactPopup>
                            kom og heiste Paul Inge opp for å fly han til Haukeland sykehus. Der var
                            kona Anne allerede på plass.
                        </Paragraph>
                        <Paragraph color="all-white">
                            For mens den dramatiske redningsoperasjonen pågikk på Malmangernuten
                            jobbet Anne og vennene deres iherdig for å finne en løsning for å få
                            henne til Haukeland sykehus. Etter en ringerunde klarer en bekjent å
                            ordne med helikoptertransport slik at hun kan være på Haukeland sykehus
                            når Paul Inge kommer.
                        </Paragraph>
                        <Quote animation="fade-up" color="primary-white">
                            – Det eneste jeg visste var at han hadde fått hjertestans og at
                            helikopteret var på vei. Det var utrolig skremmende, forteller Anne.
                        </Quote>
                    </div>
                </Content>
            </Section>
            <Section color="secondary">
                <Content width="small">
                    <InlineCTA
                        type="text"
                        color="primary"
                        buttonText="<b>Les mer om forskningsprosjektet her</b>"
                        link="/nyheter/anbefaler-heis-helikopter-luftambulansen/"
                    >
                        <Heading type="h3" color="all-black" weight="600" className="no-margin">
                            Heis i legehelikopter?
                        </Heading>
                        I dag har ikke legehelikoptrene heis, kun underhengende tau. En ny studie
                        fra Stiftelsen Norsk Luftambulanse viser at legehelikoptrene kan redde
                        pasienter både raskere og tryggere ved å innføre heis som redningsmetode.
                    </InlineCTA>
                </Content>
            </Section>
            <Section color="secondary">
                <Content width="small">
                    <Heading type="h3" color="all-white">
                        Hjertet hans stanset igjen på operasjonsbordet
                    </Heading>
                    <Paragraph color="all-white">
                        På Haukeland sykehus blir Paul Inge tatt rett med på operasjonsstua for å
                        åpne opp den fremre blokkerte hovedpulsåren rett ved hjertet.
                    </Paragraph>
                    <Paragraph color="all-white">
                        Men før kirurgen fikk startet stanset hjertet til Paul Inge igjen, i 25
                        minutter.
                    </Paragraph>
                    <Quote animation="fade-up" color="primary-white">
                        – Det var så mange tilfeldigheter den dagen som gjorde at Paul Inge er her i
                        dag. For akkurat den dagen var den beste hjertespesialisten på jobb på
                        Haukeland, familien Nyrud Uppheim møtte Paul Inge rett før hjertet hans
                        stoppet, i tillegg til at luftambulansen var like i nærheten. Det er helt
                        utrolig egentlig, smiler Anne.
                    </Quote>
                    <Quote animation="fade-up" color="primary-white">
                        – Alt klaffet for meg den dagen, sier Paul Inge.
                    </Quote>
                </Content>
            </Section>

            <ParallaxBanner
                className="parallax-banner-3"
                emergencyStripes=""
                imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/05/paul-inge-og-anne.jpg"
                alt="Paul Inge og Anne smiler sammen."
                orientation="right"
                color="off-white"
                colorTop="secondary"
                colorBottom="off-white"
            ></ParallaxBanner>

            <Section color="off-white">
                <Content width="small">
                    <Heading>Skal opp Malmangernuten til sommeren</Heading>
                    <Paragraph>
                        Etter ti dager i koma våknet Paul Inge. Han startet raskt med
                        rehabilitering, og i dag er han friskmeldt.
                    </Paragraph>
                    <Quote animation="fade-up" color="secondary">
                        Jeg er så utrolig takknemlig for alle som bidro den dagen. Det er spesielt
                        takket være Are, Heidi og Samson at jeg er her i dag. Hadde ikke de reagert
                        slik de gjorde hadde det nok ikke gått like bra, sier han.
                    </Quote>
                    <Paragraph>
                        I sommer skal Anne og Paul Inge gå opp Malmangernuten sammen med Are, Heidi
                        og Samson. Det gleder de seg til.
                    </Paragraph>
                </Content>

                <Content width="small">
                    <div className="form-wrapper supportus-form-wrapper" id="stott-oss">
                        <SupportUsForm
                            id="support-us-999"
                            level={2}
                            renderCb={renderFromDone}
                            options={[
                                {
                                    value: 250,
                                    label: '250'
                                },
                                {
                                    value: 300,
                                    label: '300'
                                },
                                {
                                    value: 400,
                                    label: '400'
                                },
                                {
                                    value: 500,
                                    label: '500'
                                }
                            ]}
                        />
                    </div>
                    {/* </div> */}
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="large">
                    <CTABlock
                        divider
                        color="secondary"
                        title="Det koster <b>ingenting</b> å være bedre forberedt"
                        innerTitle="Bli trygg på førstehjelp"
                        buttonText="<b>Akutt-ABC</b> - Et gratis digitalt førstehjelpskurs"
                        link="/akutt-abc/"
                        orientation="left"
                        imageSrc="https://norskluftambulanse.no/wp-content/uploads/2024/02/Norsk-Luftambulanse_March-2020_Kyle-Meyr_HR0046-1-e1707218019954.jpg"
                        alt="Luftambulansepersonell tar hånd om pasient på en brygge, med helikopteret og redningsskøyte i bakgrunnen."
                    >
                        <Paragraph>
                            I en nødssituasjon der noen opplever alvorlig sykdom eller skade kan det
                            å kunne førstehjelp være avgjørende for om personen overlever.
                        </Paragraph>
                        <Paragraph className="no-margin">
                            <b>Du kan friske opp hukommelsen ved å ta Akutt-ABC</b>
                        </Paragraph>
                    </CTABlock>
                </Content>
            </Section>

            <Section color="off-white">
                <Content width="small"></Content>
            </Section>
        </div>
    );
};

export default HanDodeForanOyneneVare;
